<header tds-header navigationMenuLabel="Menu">
  <div
    tds-header-app-name
    [name]="'general.app_name' | translate"
    routerLink="/historique-contrats"
    class="pointer"
  >
    <img tds-header-app-logo class="tds-header-app-logo" src="assets/images/logo.png" alt="" />
  </div>

  <tds-header-center>
    @if (mpsUserService.isLoggedIn()) {
      <nav class="tds-header-navigation" attr.aria-label="{{ 'header.aria.navigation_menu' | translate }}">
        @for (route of navigationRoutes; track route.path) {
          @if (isMenuItemDisplayed(route)) {
            @if (!route.children || route.children.length === 0) {
              <a tds-header-navigation-link [routerLink]="'/' + route.path" routerLinkActive>
                {{ route.data?.title | translate }}
              </a>
            }
            @if (route.children && route.children.length > 0) {
              <div class="nav-dropdown">
                <a tds-header-navigation-link [isActive]="isChildRouteActive(route)" class="nav-dropdown-trigger">
                  {{ route.data?.title | translate }}
                  <tds-icon name="keyboard_arrow_down" size="sm"></tds-icon>
                </a>
                <div class="nav-dropdown-menu">
                  <div>
                    @for (child of route.children; track child.path) {
                      @if (isMenuItemDisplayed(child) && child.data?.title) {
                        <a
                          [routerLink]="'/' + route.path + '/' + child.path"
                          routerLinkActive="nav-dropdown-item--active"
                        >
                          {{ child.data?.title | translate }}
                        </a>
                      }
                    }
                  </div>
                </div>
              </div>
            }
          }
        }
      </nav>
    }
  </tds-header-center>

  <tds-header-end>
    @if (!isEnvProd) {
      <span class="env-badge" [ngClass]="envName">{{ envName }}</span>
    }
    @if (user()) {
      @if (canImpersonate) {
        <div class="impersonate">
          <tds-combobox (selectionChange)="impersonateUser($event)">
            <input tds-combobox-input [formControl]="search" placeholder="{{ 'messages.label.search' | translate }}" />
            @for (user of usersToImpersonate(); track user.igg) {
              <tds-combobox-single-item [value]="user">
                {{ user.igg | uppercase }} - {{ user.firstname }} {{ user.lastname | uppercase }} |
                {{ user.role.label }}
              </tds-combobox-single-item>
            }
          </tds-combobox>
        </div>
      }

      <div
        class="user-menu-wrapper"
        (click)="toggleUserMenu()"
        (keyup.enter)="toggleUserMenu()"
        tabindex="0"
        role="button"
      >
        <div class="user-badge">
          <span class="display-name">{{ getUserDisplayName() }}</span>
          <!-- <tds-icon name="person" variant="blue"></tds-icon> -->
        </div>
        <div class="user-menu-options" [class.open]="isUserMenuOpen()">
          <a [routerLink]="logoutRoute" role="button" tabindex="0">
            {{ 'general.main_menu.logout' | translate }}
          </a>
        </div>
      </div>

      @if (translateService.getLangs().length > 1) {
        <div
          class="lang-dropdown"
          (click)="toggleDropdown()"
          (keyup.enter)="toggleDropdown()"
          tabindex="0"
          role="button"
        >
          <a class="lang-link" role="button" attr.aria-label="{{ 'header.aria.change_language' | translate }}">
            <tds-icon name="language" size="sm"></tds-icon>
            <span class="current-lang">{{ getCurrentLangLabel() }}</span>
            <tds-icon name="keyboard_arrow_down" size="sm"></tds-icon>
          </a>
          <div class="lang-options" [class.open]="isDropdownOpen()">
            @for (lang of translateService.getLangs(); track lang) {
              <a
                (click)="switchLanguage(lang)"
                (keyup.enter)="switchLanguage(lang)"
                role="button"
                tabindex="0"
                attr.aria-label="{{ 'header.aria.translate_to' | translate: { lang: getLangLabel(lang) } }}"
              >
                {{ getLangLabel(lang) }}
              </a>
            }
          </div>
        </div>
      }
    }
  </tds-header-end>

  <tds-header-mobile-menu>
    <tds-header-mobile-menu-start>
      @if (mpsUserService.isLoggedIn()) {
        <nav class="tds-header-navigation" attr.aria-label="{{ 'header.aria.navigation_menu' | translate }}">
          @for (route of navigationRoutes; track route.path) {
            @if (isMenuItemDisplayed(route)) {
              @if (!route.children || route.children.length === 0) {
                <a tds-header-navigation-link [routerLink]="'/' + route.path" routerLinkActive>
                  {{ route.data?.title | translate }}
                </a>
              }
              @if (route.children && route.children.length > 0) {
                <div
                  class="mobile-nav-group-trigger"
                  [class.mobile-nav-group-trigger--active]="isChildRouteActive(route)"
                  (click)="toggleMobileSubMenu()"
                  (keyup.enter)="toggleMobileSubMenu()"
                  tabindex="0"
                  role="button"
                >
                  {{ route.data?.title | translate }}
                  <tds-icon
                    [name]="isMobileSubMenuOpen() ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                    size="sm"
                  ></tds-icon>
                </div>
                @if (isMobileSubMenuOpen()) {
                  @for (child of route.children; track child.path) {
                    @if (isMenuItemDisplayed(child) && child.data?.title) {
                      <a
                        tds-header-navigation-link
                        class="nav-child-link"
                        [routerLink]="'/' + route.path + '/' + child.path"
                        routerLinkActive
                      >
                        {{ child.data?.title | translate }}
                      </a>
                    }
                  }
                }
              }
            }
          }
        </nav>
      }
    </tds-header-mobile-menu-start>
    <tds-header-mobile-menu-end>
      <button tds-header-mobile-menu-action [shouldCloseMenuOnClick]="true" [routerLink]="logoutRoute">
        {{ 'general.main_menu.logout' | translate }}
      </button>
    </tds-header-mobile-menu-end>
  </tds-header-mobile-menu>
</header>
